import { Link } from "react-router-dom";
import { Logo } from "./Logo";

import Returns from "@/pages/Returns";

export function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[var(--ink)] text-[var(--bone)]" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-20 md:grid-cols-12 md:px-10">
        <div className="md:col-span-5">
          <div className="invert-0 [&_rect]:fill-[var(--terra)]"><Logo /></div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-stone-300">The things everyone is talking about — headphones, serums, tumblers, sneakers — hand-picked and shipped to your door.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow text-stone-400">Shop</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/about" className="link-u">About Melic</Link></li>
            {["Audio", "Beauty", "Style", "Home", "Tech", "Fitness"].map((c) => (
              <li key={c}><Link to={`/shop?category=${c}`} className="link-u text-stone-200">{c}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow text-stone-400">Help</p>
          <ul className="mt-5 space-y-3 text-sm text-stone-200">
            <li><Link to="/returns" className="link-u">Returns &amp; refunds</Link></li>
            <li><Link to="/account" className="link-u">Your account & orders</Link></li>
            <li>Free shipping on orders over $150</li>
            <li>Pay securely with debit or credit card</li>
            <li><a href="mailto:melic@melicshop.com" className="link-u">melic@melicshop.com</a></li>
            <li><a href="tel:+14844932756" className="link-u">(484) 493-2756</a></li>
          </ul>
        </div>
      </div>
      <div className="pointer-events-none select-none px-3 font-display text-[26vw] leading-[0.78] tracking-tighter text-[#211d1a]" aria-hidden="true">Melic</div>
      <div className="mx-auto flex max-w-[1440px] justify-between px-5 py-6 text-xs text-stone-400 md:px-10">
        <span>© {new Date().getFullYear()} Melic</span>
        <span className="font-mono-x">Secure checkout by Stripe</span>
      </div>
    </footer>
  );
}
